import type { MyBookingDetail } from '@massilia/queries'

import { formatFullName } from '@massilia/features'

/** De quoi rendre « Bienvenue [civilité] [nom] », civilité comprise ou non. */
export interface BookingGreeting {
  /** Le nom mis en avant : raison sociale d'une société, sinon « Prénom NOM ». */
  name: string
  /** `null` quand on ne peut pas la connaître : mieux vaut aucune civilité qu'une fausse. */
  title: null | string
}

/**
 * Le client du dossier est la source ; le `user` du store ne sert que de repli
 * tant que le dossier n'est pas chargé.
 */
export function buildBookingGreeting(
  client: MyBookingDetail['client'] | undefined,
  user: undefined | { firstName: string; lastName: string }
): BookingGreeting {
  if (client?.clientType === 'COMPANY' && client.companyName) {
    // La raison sociale s'affiche telle qu'elle est enregistrée : la mise en
    // forme « Prénom NOM » déformerait un nom qui n'est pas celui d'une personne.
    return { name: client.companyName, title: null }
  }

  const gender = client?.gender ?? null

  let title: null | string = null
  if (gender === 'FEMALE') {
    title = 'Madame'
  } else if (gender !== null) {
    title = 'Monsieur'
  }

  return {
    name: formatFullName(
      client?.firstName ?? user?.firstName ?? '',
      client?.lastName ?? user?.lastName ?? ''
    ),
    title,
  }
}
